import { Create, Delete, GetApp } from '@mui/icons-material';
import { Button, ButtonGroup, Dialog, Grid, IconButton, Link, SvgIcon, Typography } from "@mui/material";
import Pagination from '@mui/material/Pagination';
import { styled as muiStyled } from '@mui/material/styles';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { CustomDialogActions, CustomDialogContent, CustomDialogTitle } from 'esocial.web.react.lib/cjs/components/util/Dialog';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { useBlob } from 'esocial.web.react.lib/cjs/hooks/Blob';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { abrirModalConfirmacao, fecharModalConfirmacao } from "esocial.web.react.lib/cjs/store/reducers/modais";
import { isUndefinedOrNull, rolarVisualizacaoAteElemento } from 'esocial.web.react.lib/cjs/utils/geral';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const tipoEvento = [
    { id: "45", nome: "cat" },
    { id: 46, nome: "monit-saude" },
    { id: 50, nome: "cond-ambientais" }
];

function MinusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
        </SvgIcon>
    );
}

function PlusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
        </SvgIcon>
    );
}

const ArvoreMovimentacoesTrabalhistas = muiStyled(SimpleTreeView)(() => ({
    '& .MuiCollapse-root.MuiTreeItem-group': {
        marginLeft: 0
    }
}));

const CabecalhoMovimentacoesTrabalhistas = muiStyled(TreeItem)(({ theme }) => ({
    borderBottom: '1px solid #ccc',
    backgroundColor: '#eee',
    padding: '8px 0',

    '& .MuiTreeItem-content.Mui-disabled': {
        opacity: 1,
        cursor: 'default',

        '& .MuiTreeItem-label': {
            fontWeight: theme.typography.fontWeightMedium,
            color: '#444'
        }
    }
}));

const LinkVisualizacao = muiStyled(Link)(() => ({
    textDecoration: 'none'
}));

const MovimentacaoTrabalhista = muiStyled(TreeItem)(() => ({
    borderBottom: '1px solid #ccc',

    '& .MuiTreeItem-content': {
        padding: '6px 0',
        borderRadius: 0
    },

    '& .MuiTreeItem-iconContainer': {
        marginLeft: '0.5rem'
    }
}));

const MovimentacaoTrabalhistaInterna = muiStyled(TreeItem)(({ theme }) => ({
    borderBottom: '1px solid #eee',

    '&:hover': {
        backgroundColor: theme.palette.action.hover,

        '& .MuiTreeItem-content:hover': {
            backgroundColor: 'transparent'
        }
    },

    '& .MuiLink-root.original': {
        color: theme.palette.secondary.main
    },

    '.MuiCollapse-wrapperInner &:last-of-type': {
        borderBottom: 'none'
    }
}));

const Paginador = muiStyled(Pagination)(() => ({
    marginTop: '1rem',

    '& .MuiPagination-ul': {
        justifyContent: 'right'
    }
}));

export function MovimentacoesTrabalhistas(props) {
    const { get, excluir } = useRequisicaoControlada();
    const navigate = useNavigate();
    const location = useLocation();
    const disponibilizarParaDownload = useBlob();
    const dispatch = useAppDispatch();

    const [descritorMovimentacoes, setDescritorMovimentacoes] = useState(null);
    const [eventosPorPagina] = useState(10);
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [pagina, setPagina] = useState(1);
    const [htmlResumoEvento, setHtmlResumoEvento] = useState(null);

    if (isUndefinedOrNull(props)) {
        props = {};
    }

    let { idTrabalhador, idContrato, tsv, admPreliminar, processoTrabalhista } = props;

    if (isUndefinedOrNull(tsv)) {
        tsv = false;
    }

    if (isUndefinedOrNull(admPreliminar)) {
        admPreliminar = false;
    }

    if (isUndefinedOrNull(processoTrabalhista)) {
        processoTrabalhista = false;
    }

    const processamentoResposta = (conteudoResposta) => {
        setDescritorMovimentacoes(conteudoResposta);

        const paginas = Math.ceil(conteudoResposta.totalEventos / eventosPorPagina);

        if (paginas > 1) {
            setTotalPaginas(paginas);
        }

        // Direcionar ao bloco com as movimentações trabalhistas
        rolarVisualizacaoAteElemento('bloco-movimentacoes-trabalhistas');
    };

    async function inicializar(suprimirSobreposicaoMensagens = false) {
        await get(`gestaoTrabalhadores/movimentacoesTrabalhistas/${idContrato}/${tsv}/${admPreliminar}/${eventosPorPagina}/${pagina}/${process.env.REACT_APP_IDENTIFICACAO_MODULO}`, processamentoResposta, undefined, { suprimirSobreposicaoMensagens: suprimirSobreposicaoMensagens });
    }

    const handleChangePagina = (e, value) => {
        setPagina(value);
    };

    useEffect(() => {
        if (!isUndefinedOrNull(idContrato)) {
            inicializar();
        }
    }, [pagina]);

    // Na mudança do total de páginas, acerretada por alguma exclusão feita via movimentações
    // trabalhistas, não permitir que a requisição responsável por trazer novamente as movimentações
    // atualizadas apague as mensagens presentes no container de mensagens gerais
    useEffect(() => {
        if (!isUndefinedOrNull(idContrato)) {
            inicializar(true);
        }
    }, [totalPaginas]);

    async function consultarResumoEvento(idEvento, idTipoEvento) {
        await get(`/gestaoTrabalhadores/consultarResumoEvento/${idEvento}/${idTipoEvento}`, dialogResumoEventos);
    }

    const dialogResumoEventos = (conteudoResposta) => {
        setHtmlResumoEvento(conteudoResposta);
    }

    function RenderizarAcoesMovimentacao(idTipoEvento, idEvento, idContrato, tsv, admPreliminar, listaTipoEventoMovimentacaoTrabalhistaSST) {
        // TODO: refatorar esse método para renderizar também os eventos não manipuláveis pelo módulo SST (serão somente visualização)
        if (Array.isArray(listaTipoEventoMovimentacaoTrabalhistaSST)
            && listaTipoEventoMovimentacaoTrabalhistaSST.length > 0
            && listaTipoEventoMovimentacaoTrabalhistaSST.lastIndexOf(parseInt(idTipoEvento)) >= 0) {
            return (
                <ButtonGroup size="small" aria-label="ações">
                    <IconButton
                        color="primary"
                        aria-label="retificar evento"
                        title="Retificar"
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            Retificar(idTipoEvento, idEvento, idContrato, tsv, admPreliminar);
                        }
                        }>
                        <Create />
                    </IconButton>
                    <IconButton
                        color="primary"
                        aria-label="excluir evento"
                        title="Excluir"
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            Excluir(idTipoEvento, idEvento, idContrato, tsv, admPreliminar);
                        }
                        }>
                        <Delete />
                    </IconButton>

                    <IconButton
                        color="primary"
                        aria-label="Baixar XML do evento"
                        title="baixar xml do evento"
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            BaixarXmlEvento(idEvento);
                        }
                        }>
                        <GetApp />
                    </IconButton>
                </ButtonGroup>);
        }

        // Retorno temporário para que as movimentações sem ações vinculadas tenham a mesma altura das demais
        return <div style={{ height: '30px' }}></div>;
    }

    const Consultar = (idTipoEvento, idEvento, idContrato, tsv, admPreliminar) => {
        let t = tipoEvento.filter(x => x.id == idTipoEvento)
        if (!isUndefinedOrNull(t) && t.length > 0) {
            switch (t[0].nome) {
                case "cat":
                    navigate(`/cat/visualizar/${idTrabalhador}/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`);
                    break;
                case "monit-saude":
                    navigate(`/monitoramentoSaude/visualizar/${idTrabalhador}/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`);
                    break;
                case "cond-ambientais":
                    navigate(`/exposicaoRisco/visualizar/${idTrabalhador}/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`);
                    break;
                default:
                    consultarResumoEvento(idEvento, idTipoEvento);
            }
        } else {
            consultarResumoEvento(idEvento, idTipoEvento);
        }
    }

    const Retificar = (idTipoEvento, idEvento, idContrato, tsv, admPreliminar) => {
        let t = tipoEvento.filter(x => x.id == idTipoEvento)
        if (!isUndefinedOrNull(t) && t.length > 0) {
            switch (t[0].nome) {
                case "cat":
                    navigate(`/cat/retificar/${idTrabalhador}/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`);
                    break;
                case "monit-saude":
                    navigate(`/monitoramentoSaude/retificar/${idTrabalhador}/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`);
                    break;
                case "cond-ambientais":
                    navigate(`/exposicaoRisco/retificar/${idTrabalhador}/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`);
                    break;
            }
        }
    }

    async function Excluir(idTipoEvento, idEvento, idContrato, tsv, admPreliminar) {
        const modalConfirmacaoProps = {
            texto: 'Tem certeza que deseja excluir o registro?',
            textoBotaoNao: 'Não',
            textoBotaoSim: 'Sim',
            actionBotaoNao: () => {
                dispatch(fecharModalConfirmacao());
            },
            actionBotaoSim: async () => {
                const aposExclusao = () => {
                    // Tratamento para exclusões executadas via Assinadoc
                    if (location.pathname === '/assinadoc') {
                        navigate(`/gestaoTrabalhadores`);
                    }
                    else {
                        // Atualizar as informações de paginação, se necessário
                        const novoTotalEventos = Math.max(0, descritorMovimentacoes.totalEventos - 1);
                        const novoTotalPaginas = Math.ceil((novoTotalEventos) / eventosPorPagina);

                        if (novoTotalPaginas !== totalPaginas) {
                            setTotalPaginas(novoTotalPaginas);
                        }

                        if (pagina > novoTotalPaginas) {
                            setPagina(totalPaginas);
                        }

                        // Refletir a exclusão executada na árvore de movimentações trabalhistas
                        const lista = descritorMovimentacoes.movimentacoesTrabalhistas.filter((x) => x.ultimaMovimentacao.idEvento !== idEvento);

                        setDescritorMovimentacoes(
                            {
                                ...descritorMovimentacoes,
                                movimentacoesTrabalhistas: lista,
                                totalEventos: novoTotalEventos
                            }
                        );
                    }
                };

                const t = tipoEvento.filter(x => x.id == idTipoEvento);

                if (!isUndefinedOrNull(t) && t.length > 0) {
                    switch (t[0].nome) {
                        case "cat":
                            await excluir(`sst/cat/excluir/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`, aposExclusao);
                            break;
                        case "monit-saude":
                            await excluir(`sst/monitoramentoSaude/excluirMonitoramentoSaude/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`, aposExclusao);
                            break;
                        case "cond-ambientais":
                            await excluir(`sst/exposicaoRisco/excluirExposicaoRisco/${idEvento}/${idContrato}/${tsv}/${admPreliminar}`, aposExclusao);
                            break;
                    }
                }
            }
        };

        dispatch(abrirModalConfirmacao(modalConfirmacaoProps));
    }

    async function BaixarXmlEvento(idEvento) {
        await disponibilizarParaDownload(`gestaoTrabalhadores/baixarXmlEvento/${idEvento}/${null}}`, `eSocial_Evento_${idEvento}`, 'xml', true, { suprimirSobreposicaoMensagens: true });
    }

    let nodeId = 1;

    return (!isUndefinedOrNull(descritorMovimentacoes) &&
        <Grid item style={{ width: '100%' }}>
            <Display show={descritorMovimentacoes.movimentacoesTrabalhistas.length > 0}>
                <ArvoreMovimentacoesTrabalhistas
                    id="tree-movimentacoes-trabalhistas"
                    aria-label="movimentações trabalhistas"
                    slots={{
                        expandIcon: PlusSquare,
                        collapseIcon: MinusSquare
                    }}
                >
                    <CabecalhoMovimentacoesTrabalhistas
                        itemId="header-movimentacoes-trabalhistas"
                        nodeId={`${nodeId}`}
                        disabled
                        label={
                            <Grid container justifyContent="space-between" alignItems="center" >
                                <Grid item xs={6}>Evento</Grid>
                                <Grid item xs={2} align="center">Data do Evento</Grid>
                                <Grid item xs={2} align="center">Data do Envio</Grid>
                                <Grid item xs={2} align="center">Ação</Grid>
                            </Grid>
                        }
                    />

                    {Object.entries(descritorMovimentacoes.movimentacoesTrabalhistas).map(([n, reg]) => {
                        nodeId++;

                        return (
                            <MovimentacaoTrabalhista
                                itemId={"tree-item-movimentacao-trabalhista-" + nodeId}
                                key={nodeId}
                                nodeId={`${nodeId}`}
                                label={
                                    <Grid container justifyContent="space-between" alignItems="center" >
                                        <Grid item xs={6}>
                                            {(reg.cadeiaRetificacoes.length == 0) /*&& descritorMovimentacoes.listaTipoEventoMovimentacaoTrabalhistaSST.lastIndexOf(parseInt(reg.ultimaMovimentacao.idTipoEvento)) >= 0)*/
                                                ? <LinkVisualizacao
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        Consultar(reg.ultimaMovimentacao.idTipoEvento, reg.ultimaMovimentacao.idEvento, reg.ultimaMovimentacao.idContrato, reg.ultimaMovimentacao.contratoSemVinculo, admPreliminar);
                                                    }}
                                                    title="Descrição do evento">
                                                    <Typography variant="body2"> {reg.ultimaMovimentacao.descricaoEvento}</Typography>
                                                </LinkVisualizacao> :
                                                <Typography variant="body2" title="Descrição do evento">{reg.ultimaMovimentacao.descricaoEvento}</Typography>
                                            }
                                        </Grid>
                                        <Grid item xs={2} align="center">
                                            <Typography variant="body2" title="Data de ocorrência">
                                                {reg.ultimaMovimentacao.dataOcorrenciaFormatada}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} align="center">
                                            <Typography variant="body2" title="Data de recepção">
                                                {reg.ultimaMovimentacao.dataHoraRecepcaoFormatada}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} align="center">
                                            {RenderizarAcoesMovimentacao(reg.ultimaMovimentacao.idTipoEvento, reg.ultimaMovimentacao.idEvento, reg.ultimaMovimentacao.idContrato, reg.ultimaMovimentacao.contratoSemVinculo, admPreliminar, descritorMovimentacoes.listaTipoEventoMovimentacaoTrabalhistaSST)}
                                        </Grid>
                                    </Grid>
                                }
                            >
                                {reg.cadeiaRetificacoes.length > 0 && [reg.ultimaMovimentacao].concat(reg.cadeiaRetificacoes).map((ret, id1) => {
                                    nodeId++;

                                    return (
                                        <MovimentacaoTrabalhistaInterna
                                            itemId={"tree-item-movimentacao-trabalhista-interna-" + nodeId}
                                            key={nodeId}
                                            nodeId={`${nodeId}`}
                                            label={
                                                <Grid container justifyContent="space-between" alignItems="center" >
                                                    <Grid item xs={6} align="left">
                                                        <LinkVisualizacao
                                                            href="#"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                Consultar(ret.idTipoEvento, ret.idEvento, ret.idContrato, ret.contratoSemVinculo, admPreliminar);
                                                            }}
                                                            title="Descrição do evento"
                                                            className={id1 === reg.cadeiaRetificacoes.length ? 'original' : 'retificado'}
                                                        >
                                                            <Typography variant="body2">
                                                                {id1 === reg.cadeiaRetificacoes.length ? 'Original' : 'Retificado'}
                                                            </Typography>
                                                        </LinkVisualizacao>
                                                    </Grid>
                                                    <Grid item xs={2} align="center">
                                                        <Typography variant="body2" title="Data de ocorrência">
                                                            {ret.dataOcorrenciaFormatada}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2} align="center">
                                                        <Typography variant="body2" title="Data de recepção">
                                                            {ret.dataHoraRecepcaoFormatada}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2} align="center">
                                                    </Grid>
                                                </Grid>
                                            }
                                        />
                                    );
                                })}
                            </MovimentacaoTrabalhista>
                        );
                    })}
                </ArvoreMovimentacoesTrabalhistas>

                <Display show={totalPaginas > 1}>
                    <Paginador
                        count={totalPaginas}
                        page={pagina}
                        shape="rounded"
                        showFirstButton
                        showLastButton
                        onChange={handleChangePagina}
                    />
                </Display>

                <Dialog
                    open={!isUndefinedOrNull(htmlResumoEvento) && htmlResumoEvento.length > 0}
                    onClose={() => { setHtmlResumoEvento(null); }}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth={false}
                >
                    <CustomDialogTitle id="form-dialog-title">Consultar Evento</CustomDialogTitle>
                    <CustomDialogContent>
                        {!isUndefinedOrNull(htmlResumoEvento) && htmlResumoEvento.length > 0 ?
                            parse(htmlResumoEvento) : ""
                        }
                    </CustomDialogContent>
                    <CustomDialogActions>
                        <Button variant="text" color="secondary" onClick={() => { setHtmlResumoEvento(null); }}>
                            Voltar
                        </Button>
                    </CustomDialogActions>
                </Dialog>
            </Display>

            <Display show={descritorMovimentacoes.movimentacoesTrabalhistas.length == 0}>
                <Typography variant="body2">Não foram cadastrados eventos</Typography>
            </Display>
        </Grid>
    );
}
